import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FlightRoundTripSearchResultsPagespl from '../round-trip/FlightRoundTripSearchResultsPagespl';
import FlightRoundTripIntlSearchResultsPage from './FlightRoundTripIntlSearchResultsPage';

function FlightRoundTripIntlContainer() {
  const [searchParams] = useSearchParams();
  const searchType = searchParams.get('searchtype');

  if (searchType === 'normalrt') {
    return <FlightRoundTripSearchResultsPagespl />;
  }

  return <FlightRoundTripIntlSearchResultsPage />;
}

export default FlightRoundTripIntlContainer;
